// src/store/slices/chatThunks.ts
import { createAsyncThunk } from '@reduxjs/toolkit';
import { AppDispatch, RootState } from '../store';
import { setShowLogo, resetChatSession } from './chatSlice';
import { closeRightSection } from './sectionSlice';
import { setKbStatus, resetKbItems } from './kbSlice';
import { deleteAllPdfForChat } from './pdfSlice';

export const resetChatThunk = createAsyncThunk<void, void, { dispatch: AppDispatch; state: RootState }>(
    'chat/resetChat',
    async (_, { dispatch, getState }) => {
        const state = getState();
        const messages = state.chat.messages;
        const activeChatGroup = state.chatHistory.activeChatGroup;
        
        if (messages.length > 0) {
            dispatch(setShowLogo(true));
            dispatch(resetChatSession());
            dispatch(closeRightSection());
            dispatch(setKbStatus('idle'));
            dispatch(resetKbItems());
            
            // Only clear PDFs for the current chat, not all PDFs
            if (activeChatGroup) {
                dispatch(deleteAllPdfForChat(activeChatGroup));
            }
        }
    }
);
